import React, { useContext } from "react";
import FormType from "../../../../../shared/components/FormType";
import { basicFields } from "../../../../../configs/provider";
import { PageContentWrapper } from "../../../../../shared/styled/PageContentStyle";
import { AuthenticationContext } from "../../../../../provider/AuthenticationProvider";
import { ROLE } from "../../../../../data/enums";

interface ContactPersonProps {
    validated: boolean;
    providerData: any;
    handleChangePersonContact: Function;
}

const ContactPersonForm = ({
    validated,
    providerData,
    handleChangePersonContact,
}: ContactPersonProps) => {
    const {
        user: { role },
    } = useContext(AuthenticationContext);
    const canEdit = [ROLE.MANAGER, ROLE.LOGISTIC_STAFF].includes(role);

    const getFields = () => {
        return canEdit
            ? basicFields
            : basicFields.map((item) => ({ ...item, disabled: true }));
    };

    return (
        <PageContentWrapper>
            <FormType
                title={"Thông tin nhà cung cấp"}
                requireData={providerData}
                mergeFormData={handleChangePersonContact}
                fields={getFields()}
                validated={validated}
            />
        </PageContentWrapper>
    );
};

export default ContactPersonForm;
